<script setup lang="ts">
import CatalogCategories from '~/entities/catalog/products/filters/CatalogCategories.vue';
import CatalogFilter from '~/entities/catalog/products/filters/CatalogFilter.vue';
import useCatalogStore from '~/shared/store/modules/catalog';
import AppSwitcherCheckbox from "~/components/ui/form/formElements/AppSwitcherCheckbox.vue";

const catalogStore = useCatalogStore();
const switchers = [
  {
    name: 'В наличии',
    value: 'inStock',
    active: false,
  }
]

function setFilterStatus(data: {
  value: string
  active: boolean
  name: string
  filterId: string
  filterName: string
  isBrand?: boolean
}) {
  const {isBrand, value, active, name, filterId, filterName} = data;

  if (isBrand) {
    catalogStore.setBrandsSelectedStatus({
      name,
      value,
      active,
    })
  } else {
    catalogStore.setFiltersSelectedStatus({
      value,
      active,
      name,
      filterId,
      filterName,
    })
  }
}

</script>

<template>
  <div class="catalog-sidebar">
    <CatalogCategories/>
    <div class="catalog-sidebar__filters">
      <CatalogFilter
        class="catalog-sidebar__filters-filter"
        v-for="filter in catalogStore.filters"
        :filter="filter"
        @set-filter="setFilterStatus"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.catalog {
  &-sidebar {
    width: 260px;
    min-width: 260px;

    &__filters {
      &-switcher {
        flex-direction: row-reverse;
        justify-content: space-between;
        margin-top: 26px;
        font-weight: 500;
      }
      &-filter {
        margin-top: 24px;
      }
    }
  }
}
</style>
